import ClickOutside from 'vue-click-outside'
  
  export default {
    delimiters: ['${', '}'],
    el: "#brand-app",
    props: {
      msg: {
        type: String,
        default: 'steve'
      }
    },
    data() {
      return {
        toggleAccountMenu: false,
        toggleNavMenu:false,
        currentHref:'',
        listIndex:0,
        renderComponent: true,
        user:'',
        cloaking:false
      }
    },
    directives: {
      ClickOutside
    },
    methods:{
      setCloak(cloak){
        this.$nextTick(()=>{
        this.cloaking = cloak;
        });

    },
      setUser(user){

          this.user = user;

      },
      removeAccountLink: function(target){

        // console.log(target);
        var el = this.$refs.accountMenu.querySelector('#'+target);
        // console.log(el);
        if(el){
        this.$refs.accountMenu.querySelector('#'+target).remove();
        }

      },
      removeNavLink(target){
        // console.log(target);
        var el = this.$refs.linkMenu.querySelector('#'+target);
        // console.log(el);
        if(el){
        this.$refs.linkMenu.querySelector('#'+target).remove();
        }
      },
      setActiveNav: function(target){

        var items =  this.$refs.linkMenu.querySelectorAll('a');
  
        items.forEach(function(item) {
          item.classList.remove('dtop:tw-border-primary');
        });
        var el = this.$refs.linkMenu.querySelector('#'+target);
        
        if(el){
        el.classList.add('dtop:tw-border-primary');
        }
        
      },
      hideNav: function(){
        // console.log(this.$mq);
      if(this.$mq === 'sm'){
        if(typeof ssApp != "undefined"){
          if(this.toggleNavMenu === true){match
            ssApp.$root.$emit('toggleMenu');
          }
          this.toggleNavMenu = false;
          this.toggleAccountMenu = false;
        }else{
          this.toggleNavMenu = false;
          this.toggleAccountMenu = false;
        }
      }
      },
      test: function(){
        // console.log('check');
      },
      tabDown: function(){
        // console.log('tab');
        // console.log(this.$refs.listMenu.children.length-1);
        //  console.log('last index '+ this.listIndex);
        if(this.toggleAccountMenu && this.$refs.listMenu.children.length-1 == this.listIndex){
          // console.log('alert');
          this.toggleAccountMenu= false;
          this.listIndex=0; 
        }else{
          this.downMenu();

        }

      },
      hideAccount: function(){
        
        // console.log(this.toggleNavMenu);
        if(typeof ssApp != "undefined"){
          if(this.toggleNavMenu === true){
            // ssApp.$root.$emit('toggleMenu');
          }
          this.toggleAccountMenu = false;
        }else{
     
          this.toggleAccountMenu = false;
        }
      },
      search: function(){
        if(typeof ssApp != "undefined"){
          ssApp.showSearch = true;
          ssApp.$root.$emit('searchToggle');
          setTimeout(function(){ ssApp.showSearch = true}, 1);
        }else{
          window.location = '/portal18/search';
        }
      },
      accountToggle: function(){
        // console.log('account toggle down');
        this.toggleNavMenu = false;
        this.toggleAccountMenu = this.toggleAccountMenu == true ? false : true;
  

       this.$nextTick(()=>{

        //  this.$refs.accountMenu.querySelector('ul>li>a').focus();
        // this.$refs.listMenu.querySelector('a').focus();
          let h = this.$refs.accountButton.offsetHeight;
          let w = this.$refs.accountButton.offsetWidth;
  
          this.$refs.accountMenu.style['min-width'] = w+"px";
          this.$refs.accountMenu.style.top = h+"px";
  
          let width = this.$refs.accountMenu.clientWidth;
          // console.log(width);
          let body = document.querySelector('body');
          let bounding = this.$refs.accountMenu.getBoundingClientRect();
          let diff =  ( body.clientWidth- bounding.right) - 10
   
       //if the dropdown menu overflows with width, move the menu over
          if(bounding.right > body.clientWidth){
            this.$refs.accountMenu.style.left = diff+"px";
            this.$refs.accountMenu.style['min-width'] = w+"px";
            this.$refs.accountMenu.style.width = width+"px";
            this.$refs.accountMenu.style.top = h+"px";
          }
          // console.log(this.$refs.accountMenu);
        })
      },
      upMenu: function(){ 
        // console.log('up');
         if(this.listIndex > 0){
            this.listIndex--;
         
          }else{
            this.listIndex=this.$refs.listMenu.children.length-1;  
          }
          //  this.$refs.listMenu.children[this.listIndex].querySelector('a').focus();
      },
      downMenu: function(){
   
        // console.log('down');

        // console.log(this.$refs.listMenu.children.length-1 + ''+  this.listIndex);

          if(this.listIndex < this.$refs.listMenu.children.length-1){
            this.listIndex++;
            // console.log(this.listIndex);
         
          }else{
            this.listIndex=0; 
          }
          //  this.$refs.listMenu.children[this.listIndex].querySelector('a').focus();
      },
      closeMenu: function(){
          this.data.open = this.data.open == false ? true: false; 
      },
      menuToggle: function(){
        this.toggleAccountMenu = false;
        if(typeof ssApp != "undefined"){
  
            ssApp.$root.$emit('toggleMenu');
           
        }else if (typeof window.w4 != 'undefined'){
            window.w4.toggleNavigation()
            
        }
        
        this.toggleNavMenu = this.toggleNavMenu == true ? false : true;
        
      },
      handleHref: function(e){
         e.preventDefault();



        // alert('href');


        // if mobile
        if(this.$mq === 'sm'){
          // if element has sub sublinks
          if(e.target.attributes['data-sublinks'].value === 'true'){
            // console.log('sub links');
              // the item clicked is the same
              if(this.currentHref === e.target.attributes.href.value ){
                  this.currentHref= '';
                   this.toggleNavMenu = false;
              }else{
                // console.log('hey');
                  this.currentHref= e.target.attributes.href.value;
              }  

              // console.log(this.currentHref);
          }else{
              // at the top level always turn the nav off,  this will force spa apps to toggle nav off even if the page does not reload, 
              // but typically it will just load the new page
              this.toggleNavMenu = false;

              window.location.href = e.target.attributes.href.value;
          }

        }else{
  
          // all apps funnel href to this href location change, if there is a 
          // make sure the attribute has target or else it will be undefined and that is bad
          // target we handle that as well, that is only for workflow legacy apps,
          let target = e.target?.attributes['target']?.value ;
          console.log(target);
           if(target === '' || target ===  undefined){
            window.location.href = e.target.attributes.href.value;
          // todo not ready until wf legacy has attribute type
           }else{
          
            window.open(e.target.attributes.href.value,e.target.attributes.target.value);
           }
        }

    
      }

    },
    computed: {
      // this could be removed, not used in template
      currentHrefComputed: function(){
        return this.currentHref;
      }
    }

  }


